// tslint:disable:max-file-line-count
import * as React from 'react';
import { Component } from 'react';

import {
  getKeyboardEventCode,
  IDropdownValue,
  mergeStyles,
  Popup,
  PopupArrow,
  Preloader,
} from '@cian/components';
import { OutsideClick } from '@cian/outside-click-component';
import { TextField } from '@cian/text-field-component';

import { scrollTo } from '@cian/utils/lib/shared/scroll_to';

import { createMakeRequest } from '../../../../browser/client';
import { isYandexGeo } from '../../../helpers/analytics_helper';
import * as Analytics from '../../../helpers/analytics_helper';
import { IAddressSuggestion, IGetAddressSuggestions } from '../../../helpers/geo_suggest';
import { IMakeRequest } from '../../../helpers/network_helper';
import { INewbuildingSuggestion } from '../../../helpers/newbuildings_geo_suggest';
import {
  IUserGeoDefinitionWithFilter,
  IUserGeoSearch,
} from '../../../models/filters/user_geo';
import { IGeoValue } from '../../../redux/modules/search/search';
import {getGeoBoundedBy, hasNoSuggestions, IGeoObject, sendGeocode} from './geo_suggest/geo_helpers';
import {
  applySuggestSearchModeForSuggestionsParams,
  areSuggestsGrouped,
  detectSuggestSearchMode,
  getCombinedSuggestions,
  getGeoRegionName,
  IGeoSuggestGroup,
  IGeoSuggestItem,
  isNewbuildingsSuggestion,
  Suggestion,
  TSuggestSearchMode,
} from './geo_suggest/suggests_helpers';
import { isAddressSuggestion, Suggestions } from './geo_suggest/suggests_helpers';
import { textSearch } from './geo_suggest/text_search';

interface IUserGeoStrictFilterProps {
  section: string;
  regionOrMaintownId: number;
  regions: IDropdownValue[];
  cities: IDropdownValue[];
  onGeoSuggestChange: (geoSuggest: string | void) => void;
  isNewbuildingsGeosuggestActive: boolean;
  geoValue?: IGeoValue;

  onChange(
    userGeoDefinitionWithFilter: IUserGeoDefinitionWithFilter,
    userGeoSearch: IUserGeoSearch,
  ): void;

  onGeoSelected(value: IGeoObject): void;

  getNewbuildingsSearchSuggestions(text: string, region: number | undefined): Promise<INewbuildingSuggestion[]>;
  getAddressSuggestions: IGetAddressSuggestions;

  onLinkClick?(suggestion: IGeoSuggestItem<Suggestion>): void;
}

interface IUserGeoStrictFilterState {
  text?: string;
  suggestions?: Suggestions;
  isPopupOpen?: boolean;
  isLoad?: boolean;
  selectedItemIndex?: number;
  selectedValue?: string;
  error?: boolean;
  geoBoundedBy?: [IYmapsCoord, IYmapsCoord];
  defaultGeoText?: string;
}

const MAX_LENGTH_INPUT_TEXT = 255;

// default displayed Moscow
const BOUNDED_BY_DEFAULT: [IYmapsCoord, IYmapsCoord] = [
  [56.021224, 37.967428],
  [55.142175, 36.803101],
];

const styles = require('../search_filters.css');

export class UserGeoStrictFilter extends Component<IUserGeoStrictFilterProps, IUserGeoStrictFilterState> {
  protected container: HTMLDivElement;
  protected suggestionElements: HTMLDivElement[];
  private makeRequest: IMakeRequest;
  private geoInput: TextField;
  private suggestionLastIndex = 0;

  public constructor(props: IUserGeoStrictFilterProps) {
    super(props);

    const text = getGeoRegionName(
      props.cities,
      props.regions,
      props.regionOrMaintownId,
      props.geoValue,
    );

    const defaultGeoText = text || props.regions[0].label;

    this.state = {
      error: false,
      isLoad: false,
      isPopupOpen: false,
      selectedItemIndex: 0,
      selectedValue: defaultGeoText,
      suggestions: [],
      text: defaultGeoText,
      defaultGeoText,
    };
  }

  public componentWillReceiveProps(nextProps: IUserGeoStrictFilterProps) {
    // Если поменяли регион или ЖК в геосаджесте, то меняем текст кнопки
    if (
      this.props.regionOrMaintownId !== nextProps.regionOrMaintownId ||
      this.props.geoValue !== nextProps.geoValue
    ) {
      const text = getGeoRegionName(
        this.props.cities,
        this.props.regions,
        nextProps.regionOrMaintownId,
        nextProps.geoValue,
      );

      if (text) {
        this.setState({
          text,
          defaultGeoText: text,
          selectedValue: text,
        });
      }
    }
  }

  public componentDidMount() {
    this.makeRequest = createMakeRequest(
      window.__mainpage_api_host__ || window.location.host,
    );

    const { regionOrMaintownId } = this.props;

    getGeoBoundedBy(this.makeRequest, regionOrMaintownId)
      .then((response) => {
        this.setState({
          geoBoundedBy: [
            [response.data.boundedBy.upperCorner.lat, response.data.boundedBy.upperCorner.lng],
            [response.data.boundedBy.lowerCorner.lat, response.data.boundedBy.lowerCorner.lng],
          ],
        });
      })
      .catch(error => {
        this.setState({
          // Если случилась ошибка, по умолчанию ранжируем suggest по Москве
          geoBoundedBy: BOUNDED_BY_DEFAULT,
        });
      });
  }

  public render() {
    const { isNewbuildingsGeosuggestActive } = this.props;

    this.suggestionElements = [];

    return (
      <div
        role="search"
        {...mergeStyles(
          styles['c-filters-field'],
          styles['c-filters-field-region'],
        )}
      >
        {
          this.state.isLoad &&
            <div className={styles['c-filterst-field_container-preloader']}>
              <Preloader />
            </div>
        }
        <OutsideClick
          onOutsideClick={() => this.handleOutsideClick()}
          rootElement={<div className={styles['c_filters-suggest_input_wrapper']} />}
        >
          <label
            htmlFor="c_filters-suggest_input"
            className={styles['c_filters-geo_input_label']}
          >
            {`Город, адрес, метро, район, шоссе${isNewbuildingsGeosuggestActive ? ' или ЖК' : ''}`}
          </label>
          <TextField
            ref={(geoInput: TextField) => this.geoInput = geoInput}
            id="c_filters-suggest_input"
            inputStyle={
              `${styles['c_filters-suggest_input_field']}
               ${styles['c_filters-suggest_input_field--small']}`
            }
            value={this.state.text || ''}
            onValueChange={newText => this.handleNextTextChange(newText)}
            onKeyDown={event => this.handleKeyDown(event)}
            onFocus={this.handleFocusGeoInput}
          />
          <button
            type="button"
            {...mergeStyles(
              styles['c_filters-suggest_input-drop_icon'],
              styles['c_filters-suggest_input-drop_icon--strict_filter'],
              this.state.isPopupOpen && styles['c_filters-suggest_input-drop_icon--opened'],
            )}
            onClick={() => this.handleDropDownChevronClick()}
          ></button>
          {
            this.state.isPopupOpen &&
              <Popup
                arrow={PopupArrow.LEFT}
                containerStyle={styles['c_filters-suggest_popup']}
              >
                <div
                  ref={(container: HTMLDivElement) => this.container = container}
                  className={styles['c_filters-suggest_popup-content']}
                >
                  <div>
                    {
                      this.state.error
                        ? this.renderError()
                        : this.renderSearchList(this.state.suggestions || [])
                    }
                  </div>
                </div>
              </Popup>
            }
        </OutsideClick>
      </div>
    );
  }

  public scrollTo(index: number, center: boolean = false) {
    const containerElement = this.container;
    const valueElement = this.suggestionElements[index];

    if (!valueElement) {
      return;
    }

    scrollTo({ center, containerElement, targetElement: valueElement });
  }

  private handleDropDownChevronClick = () => {
    if (this.state.isPopupOpen) {
      this.geoInput.blur();
      this.handleOutsideClick();
    } else {
      this.geoInput.focus();
    }
  }

  private renderError() {
    return (
      <div className={styles['c_filters-suggested_message_geo']}>
        <div className={styles['c_filters-suggested_message_text']}>
          <div className={styles['c_filters-suggested_message_text--title']}>
            <strong>Не удалось получить возможные варианты</strong>
          </div>
          <div className={styles['c_filters-suggested_message_text--light']}>
            Попробуйте еще раз
          </div>
        </div>
      </div>
    );
  }

  private renderNoSuggestions = () => {
    return (
      <div className={styles['c_filters-suggested_message_geo']}>
        <div className={styles['c_filters-suggested_message_text']}>
          <div className={styles['c_filters-suggested_message_text--title']}>
            <strong>Ничего не найдено</strong>
          </div>
          <div className={styles['c_filters-suggested_message_text--light']}>
            Укажите другой адрес
          </div>
        </div>
      </div>
    );
  }

  private renderSuggestion = (item: IGeoSuggestItem<Suggestion>, isGrouped?: boolean) => {
    const text = item.title;
    const index = this.suggestionLastIndex++;

    return (
      <div
        ref={(valueElement: HTMLDivElement) => this.suggestionElements[index] = valueElement}
        key={`${text}${index}`}
        {...mergeStyles(
          styles['c_filters-suggested_items'],
          styles['c_filters-suggested_items--without_checked'],
          isGrouped ? styles['c_filters-suggested_items--grouped'] : '',
          this.state.selectedItemIndex === index && styles['c_filters-suggested_items--focus'],
        )}
        onClick={() => this.handleGeoSuggestItemClick(item)}
        onMouseOver={() => this.handleMouseOverGeoItem(index)}
      >
        <div>
          <div>
            {this.renderTitle(item.title)}
            {this.renderSubtitle(item.subTitle)}
          </div>
          {this.renderLink(item)}
        </div>
      </div>
    );
  }

  private renderTitle(title: string) {
    const value = (this.state.text || '').trim();

    if (!value) {
      return (
        <span>
          {title}
        </span>
      );
    }

    const startIndex = textSearch.indexOf(title, value);
    if (startIndex === -1) {
      return (
        <span>
          {title}
        </span>
      );
    }

    const endIndex = startIndex + value.length;

    return (
      <span>
        {title.substring(0, startIndex)}
        <strong>
          {title.substring(startIndex, endIndex)}
        </strong>
        {title.substring(endIndex)}
      </span>
    );
  }

  private renderSubtitle(subtitle: string | undefined) {
    if (!subtitle) {
      return;
    }

    return (
      <p className={styles['c_filters-suggested-items--desc']}>
        {subtitle}
      </p>
    );
  }

  private renderLink(item: IGeoSuggestItem<Suggestion>) {
    if (!item.externalLink) {
      return;
    }

    const { onLinkClick } = this.props;

    return (
      <a
        className={styles['c_filters-suggested-items--link']}
        href={item.externalLink}
        target="_blank"
        onClick={() => onLinkClick && onLinkClick(item)}
      />
    );
  }

  private renderSuggestionsGroup = (group: IGeoSuggestGroup<Suggestion>, groupIndex: number) => {
    const { items, title } = group;

    if (items.length === 0) {
      return null;
    }

    return (
      <div className={styles['group-group']} key={`group-${groupIndex}`}>
        <div className={styles['c_filters-suggested-group-title']}>{title}</div>
        {items.map(item => this.renderSuggestion(item, true))}
      </div>
    );
  }

  private renderSearchList(suggestions: Suggestions) {
    this.suggestionLastIndex = 0;

    if (suggestions.length === 0) {
      return this.renderNoSuggestions();
    }

    if (areSuggestsGrouped(suggestions)) {
      return suggestions.map(this.renderSuggestionsGroup);
    } else {
      return suggestions.map(item => this.renderSuggestion(item));
    }
  }

  private handleFocusGeoInput = () => {
    const {section} = this.props;
    const {selectedValue, text} = this.state;

    this.setState({error: false, isLoad: true, text: `${selectedValue} `});

    Analytics.clickUserGeoStrictFilter(section);

    if (isYandexGeo(section)) {
      Analytics.trackYandexGeoSuggestClick();
    }

    this.getGeoSuggestion(text || '');
  }

  private selectItem = (index: number) => {
    if (this.suggestionLastIndex === 0) {
      return;
    }

    if (index < 0) {
      index = this.suggestionLastIndex - 1;
    } else if (index > this.suggestionLastIndex - 1) {
      index = 0;
    }

    if (this.state.selectedItemIndex === index) {
      return;
    }

    this.setState({
      selectedItemIndex: index,
    });

    this.scrollTo(index);
  }

  private handleKeyDown = (event: React.KeyboardEvent) => {
    if (!this.state.suggestions || this.state.suggestions.length === 0) {
      return;
    }

    const nativeEvent = event.nativeEvent as KeyboardEvent;
    const code = getKeyboardEventCode(nativeEvent);

    const selectedItemIndex = this.state.selectedItemIndex || 0;

    switch (code) {
      case 'ArrowDown':
      case 'Down':
        event.preventDefault();
        this.selectItem(selectedItemIndex + 1);
        break;

      case 'ArrowUp':
      case 'Up':
        event.preventDefault();
        this.selectItem(selectedItemIndex - 1);
        break;

      case 'Tab':
      case 'NumpadEnter':
      case 'Enter':
        event.preventDefault();
        this.handleEnterPress();
        break;

      case 'Escape':
        this.setState({
          isPopupOpen: false,
          selectedItemIndex: 0,
          text: this.getTextDisplayed(this.state.selectedValue || ''),
        });
        break;

      default:
        break;
    }
  }

  private handleEnterPress() {
    if (!this.state.suggestions || this.state.suggestions.length === 0) {
      return;
    }

    const selectedItemIndex = this.state.selectedItemIndex || 0;

    this.geoInput.blur();

    const suggestions = this.state.suggestions;
    let index = selectedItemIndex;

    if (areSuggestsGrouped(suggestions)) {
      for (let i = 0; i <= suggestions.length - 1; i++) {
        const suggestionsGroup = suggestions[i];

        if (suggestionsGroup.items.length - 1 < index) {
          index -= suggestionsGroup.items.length;
          continue;
        }

        this.handleItemClick(suggestionsGroup.items[index]);
        break;
      }
    } else {
      this.handleItemClick(suggestions[index]);
    }
  }

  private handleItemClick = (item: IGeoSuggestItem<Suggestion>) => {
    this.setState({
      isPopupOpen: false,
      selectedItemIndex: 0,
      text: item.title,
    }, () => this.handleGeoSuggestItemClick(item));
  }

  private handleMouseOverGeoItem(index: number) {
    this.setState({
      selectedItemIndex: index,
    });
  }

  private handleNextTextChange(newText: string) {
    const suggestSearchMode = detectSuggestSearchMode(this.state.defaultGeoText || '', newText);

    this.setState({
      error: false,
      text: newText,
    });

    this.getGeoSuggestion(newText, suggestSearchMode);
  }

  private handleOutsideClick() {
    this.setState({
      isPopupOpen: false,
      selectedItemIndex: 0,
      text: this.getTextDisplayed(this.state.selectedValue || ''),
    });
  }

  private handleGeoSuggestItemClick(item: IGeoSuggestItem<Suggestion>) {
    const value = item.title;
    const newValue = this.getTextDisplayed(value);

    this.setState({
      isPopupOpen: false,
      selectedValue: value,
      text: newValue,
    });

    this.props.onGeoSuggestChange(value);

    if (isNewbuildingsSuggestion(item)) {
      const newbuilding = item.value as INewbuildingSuggestion;

      Analytics.changeValueUserGeoStrictFilter(this.props.section, 'JK');

      this.props.onGeoSelected({
        coordinates: [Number(newbuilding.Lng), Number(newbuilding.Lat)],
        id: newbuilding.Id,
        locationId: newbuilding.LocationId,
        text: newbuilding.Name,
        type: 'newobject',
      } as IGeoObject);
    } else if (isAddressSuggestion(item)) {
      sendGeocode(
        this.makeRequest,
        value,
        this.props.section,
        this.props.onChange,
        this.setErrorState,
        false,
      );
    }
  }

  private getTextDisplayed(value: string): string {
    return value.length > MAX_LENGTH_INPUT_TEXT
      ? `${value.slice(0, MAX_LENGTH_INPUT_TEXT).trim()}...`
      : value;
  }

  private setErrorState = () => {
    this.setState({ error: true });
  }

  private getGeoSuggestion(searchText: string, suggestSearchMode?: TSuggestSearchMode) {
    const { defaultGeoText = '' } = this.state;

    const {
      section,
      regionOrMaintownId,
      getAddressSuggestions,
      isNewbuildingsGeosuggestActive,
      getNewbuildingsSearchSuggestions,
    } = this.props;

    const {
      newbuildingsRegionId,
      newbuildingsSearchText,
      isNewbuildingsGeosuggestEnabledForSearchMode,
    } = applySuggestSearchModeForSuggestionsParams(searchText, defaultGeoText, regionOrMaintownId, suggestSearchMode);

    const newbuildingsSuggestPromise =
      newbuildingsSearchText &&
      isNewbuildingsGeosuggestActive &&
      isNewbuildingsGeosuggestEnabledForSearchMode
        ? getNewbuildingsSearchSuggestions(newbuildingsSearchText.trim(), newbuildingsRegionId)
        : Promise.resolve([] as INewbuildingSuggestion[]);

    const addressSuggestPromise = getAddressSuggestions(`Россия, ${searchText}`, {
      boundedBy: this.state.geoBoundedBy || BOUNDED_BY_DEFAULT,
      results: 20,
    });

    Promise.all([addressSuggestPromise, newbuildingsSuggestPromise])
      .then((result: [IAddressSuggestion[], INewbuildingSuggestion[]]) => {
        let [ addressSuggestions, newbuildingsSuggestions ] = result;

        let suggestions = getCombinedSuggestions(
          addressSuggestions,
          newbuildingsSuggestions,
        );

        if (isYandexGeo(section) && hasNoSuggestions(suggestions)) {
          Analytics.trackYandexGeoSuggestNotFound(searchText);
        }

        this.setState({
          isLoad: false,
          isPopupOpen: true,
          suggestions,
        });
      })
      .catch(() => {
        this.setErrorState();
      });
  }
}
